import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function removeUnwantedCharacters(value) {
  const args = value !== null && value !== void 0 ? value : '';
  return Array.isArray(args) ? value.map(removeUnwantedCharacters) : removeCharacters(args);
}
function removeCharacters(value) {
  if (typeof value === 'object') {
    const {
      keyField
    } = value;
    if (!keyField) return value;
    return _objectSpread(_objectSpread({}, value), {}, {
      [keyField]: removeUnwantedCharacters(value[keyField])
    });
  }
  return String(value).replace(/^\|\s/, '').replace(/\|$/, '').trim();
}
export default removeUnwantedCharacters;
//# sourceMappingURL=remove-unwanted-characters.js.map